let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bT7wh")).then(() => parcelRequire('bewIs'));